/**
 * 位置情報フォールバック用の名古屋駅座標
 * バックエンドのテストファイル(test_geo.py)と同じ座標値を使用
 */
export const NAGOYA_STATION_FALLBACK = {
  latitude: 35.17096,
  longitude: 136.8815422,
  name: "名古屋駅（代表地点）"
} as const;
